import React from 'react';
import webserviceModel from './model/webserviceModel';
import { SelectBasePrototype } from 'clad';

export const SelectWebserviceAuthentication = React.forwardRef((props, ref) => {
    const { data, value, onChange, mode, placeholder } = props;
    const handleFetch = () => webserviceModel.listWebserviceAuthentication();

    return (
        <SelectBasePrototype
            mode={mode}
            placeholder={placeholder || _('Select a authentication')}
            schema={{ idOption: 'id', option: 'name' }}
            fetch={handleFetch}
            onChange={onChange}
            value={value}
            data={data}
        />
    );
});
